export default {
  ipLoginLoadingState(state) {
    return state.ipLoginLoading;
  },
};
